import script from "./ExpenseCategorySelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseCategorySelect.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseCategorySelect.vue?vue&type=style&index=0&id=4ca0d54e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ca0d54e"]])

export default __exports__